export default {
  API_BASE_URL: process.env.API_BASE_URL || process.env.VUE_APP_API_BASE_URL || "https://api.animaapp.com",
  STIGG_API_KEY: process.env.VUE_APP_STIGG_API_KEY || 'client-a3e6851f-9607-4344-b3da-dffcb2a1db50:94e13372-a861-4221-bc2e-7c5c8634e1d4',
  STIGG_URL: process.env.VUE_APP_STIGG_URL || 'https://app.stigg.io/production-18a3efa2',
  GOOGLE_AUTH_CLIENT_ID:
    process.env.GOOGLE_AUTH_CLIENT_ID ||
    "96418805951-u0rodi91te53odo9m53ioaqkav32pftp.apps.googleusercontent.com",
};
